import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { TypeUtils } from "../../shared/utilities/typeUtils";
import { IReviewsAggregate, IReviewsSummary } from "./reviewsAggregate";
import { IReviewWidgetPagerRatingsFilter, ReviewWidgetPagerRatingsFilter } from "./reviewWidgetPagerRatingsFilter";
import { IReviewWidgetPagerReviews, ReviewWidgetPagerReviews } from "./reviewWidgetPagerReviews";
import { IReviewWidgetPagerShowMore, ReviewWidgetPagerShowMore } from "./reviewWidgetPagerShowMore";

export interface IReviewWidgetPager extends IInstanceComponentBase {
    isEof: boolean;
    page: number;
    update:(selectedRating:number, reviewsSummary: IReviewsSummary, page: number, newReviews: string, clearReviews: boolean) => void;
}

export class ReviewWidgetPager extends InstanceComponentBase implements IReviewWidgetPager {
    public reviewWidgetPagerRatingsFilter: IReviewWidgetPagerRatingsFilter;
    public reviewWidgetPagerReviews: IReviewWidgetPagerReviews;
    public reviewWidgetPagerShowMore: IReviewWidgetPagerShowMore;
    public isEof: boolean;
    public isDisabled: boolean;
    public page: number;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.setPage();
        this.setIsEof();
        this.setIsDisabled();

        this.createReviewWidgetPagerRatingsFilter();
        this.createReviewWidgetPagerReviews();
        this.createReviewWidgetPagerShowMore();
    }

    createReviewWidgetPagerRatingsFilter():void{
        let reviewWidgetPagerRatingsFilterElement: HTMLElement | null = this.getHtmlElementForReviewWidgetPagerRatingsFilter();
        if (reviewWidgetPagerRatingsFilterElement) {
            this.reviewWidgetPagerRatingsFilter = new ReviewWidgetPagerRatingsFilter(reviewWidgetPagerRatingsFilterElement);
        }
    }

    getHtmlElementForReviewWidgetPagerRatingsFilter():HTMLElement{
        let reviewWidgetPagerRatingsFilterElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.reviewWidgetPagerRatingsFilter))
        return reviewWidgetPagerRatingsFilterElement;
    }

    createReviewWidgetPagerReviews():void{
        let reviewWidgetPagerReviewsElement: HTMLElement | null = this.getHtmlElementForReviewWidgetPagerReviews();
        if (reviewWidgetPagerReviewsElement) {
            this.reviewWidgetPagerReviews = new ReviewWidgetPagerReviews(reviewWidgetPagerReviewsElement);
        }
    }

    getHtmlElementForReviewWidgetPagerReviews():HTMLElement{
        let reviewWidgetPagerReviewsElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.reviewWidgetPagerReviews))
        return reviewWidgetPagerReviewsElement;
    }

    createReviewWidgetPagerShowMore():void{
        let reviewWidgetPagerShowMoreElement: HTMLElement | null = this.getHtmlElementForReviewWidgetPagerShowMore();
        if (reviewWidgetPagerShowMoreElement) {
            this.reviewWidgetPagerShowMore = new ReviewWidgetPagerShowMore(reviewWidgetPagerShowMoreElement, this.isEof, this.page, this.isDisabled, this.reviewWidgetPagerRatingsFilter.selectedRating);
        }
    }

    getHtmlElementForReviewWidgetPagerShowMore():HTMLElement{
        let reviewWidgetPagerShowMoreElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetPagerShowMore.reviewWidgetPagerShowMore))
        return reviewWidgetPagerShowMoreElement;
    }
    
    setPage(): void {
        this.page = +this.htmlElement.getAttribute(AttributeEnums.ReviewComponents.reviewWidgetPagerPage);
    }

    writeToPage(page: number): void {
        this.htmlElement.setAttribute(AttributeEnums.ReviewComponents.reviewWidgetPagerPage, page.toString());
    }

    updatePage(page: number): void {
        this.writeToPage(page);
        this.setPage();
    }

    setIsEof(): void {
        if(this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.reviewWidgetPagerIsEof, 'true'))){
            this.isEof = true;
        }else{
            this.isEof = false;
        }
    }

    updateIsEof(): void {
        this.setIsEof();
    }

    setIsDisabled(): void {
        this.isDisabled = this.isEof;
    }
    updateIsDisabled(): void {
        this.setIsDisabled();
    }

   updateReviewWidgetPagerShowMore(selectedRating:number){
        this.reviewWidgetPagerShowMore.update(this.isEof, this.page, this.isDisabled, selectedRating);
   }

    update(selectedRating:number, reviewsSummary: IReviewsSummary, page: number, newReviews: string, clearReviews: boolean):void{
        this.reviewWidgetPagerReviews.update(newReviews, clearReviews);
        this.reviewWidgetPagerRatingsFilter.update(selectedRating, reviewsSummary);
        this.updatePage(page);
        this.updateIsEof();
        this.updateIsDisabled();
        this.updateReviewWidgetPagerShowMore(selectedRating);

        console.log(`ReviewWidgetPager: update`);
    }

    dispose() {
        try {
            console.log(`ReviewWidgetPager: dispose`);
           
            if (this.reviewWidgetPagerRatingsFilter) {
                this.reviewWidgetPagerRatingsFilter.dispose();
            }
            if (this.reviewWidgetPagerReviews) {
                this.reviewWidgetPagerReviews.dispose();
            }
            if (this.reviewWidgetPagerShowMore) {
                this.reviewWidgetPagerShowMore.dispose();
            }
          
        } catch (error) {
            console.log('ReviewWidgetPager: dispose ERROR', error);
        }
    }
}